import { ChartFrequency, IComposableChartsWidget } from 'wisestep-api';

import { generalTimePeriodList } from '../../../../../features/analyticsPage/helper/timePeriodList';
import FollowUpMetricPostgres from '../../../../../features/composableAnalytics/BaseCharts/followUps/postgres/FollowUpMetricPostgres';
import FollowUpStackedBarChartPostgres from '../../../../../features/composableAnalytics/BaseCharts/followUps/postgres/FollowUpStackedBarChartPostgres';
import FollowUpTablePostgres from '../../../../../features/composableAnalytics/BaseCharts/followUps/postgres/FollowUpTablePostgres';
import { ChartScope } from '../../../types';
import { FollowUpWidget, getChartFreqForTimePeriod } from '../../helper';

const followUpWidgetsByTimeAndScope = (
  timePeriodId: string,
  scope: ChartScope,
  frequency: ChartFrequency = getChartFreqForTimePeriod[timePeriodId]
): Record<FollowUpWidget, IComposableChartsWidget> => {
  const defaultQuery = {
    category: 'followUps',
    filters: [],
    type: 'task-count',
    range: timePeriodId,
    scope,
    frequency,
  };

  const widgetConfig: Record<FollowUpWidget, IComposableChartsWidget> = {
    [FollowUpWidget.TASK_COUNT_CREATED]: {
      text: 'Total Follow Ups Created',
      name: 'Total Follow Ups Created',
      filters: {},
      category: 'followUps',
      type: `metric_followUps_total_created_${timePeriodId}_${scope}_postgre`,
      component: (
        <FollowUpMetricPostgres
          query={{
            ...defaultQuery,
            type: 'TASK_COUNT',
            filters: [
              {
                filterName: 'STATUS',
                values: ['OPEN', 'CLOSED'],
              },
            ],
          }}
          title="Follow Ups"
          widgetName={FollowUpWidget.TASK_COUNT_CREATED}
        />
      ),
    },
    [FollowUpWidget.TASK_COUNT_OPEN]: {
      text: `Total Follow Ups Open`,
      name: `Total Follow Ups Open`,
      filters: {},
      category: 'followUps',
      type: `metric_followUps_total_open_${timePeriodId}_${scope}_${frequency}_postgre`,
      component: (
        <FollowUpMetricPostgres
          query={{
            ...defaultQuery,
            type: 'TASK_COUNT',
            filters: [
              {
                filterName: 'STATUS',
                values: ['OPEN'],
              },
            ],
          }}
          title="Follow Ups - Open"
          widgetName={FollowUpWidget.TASK_COUNT_OPEN}
        />
      ),
    },
    [FollowUpWidget.TASK_COUNT_CLOSED]: {
      name: 'Total Follow Ups Closed',
      text: 'Total Follow Ups Closed',
      filters: {},
      category: 'followUps',
      type: `metric_followUps_total_closed_${timePeriodId}_${scope}_postgre`,
      component: (
        <FollowUpMetricPostgres
          query={{
            ...defaultQuery,
            type: 'TASK_COUNT',
            filters: [
              {
                filterName: 'STATUS',
                values: ['CLOSED'],
              },
            ],
          }}
          title="Follow Ups - Closed"
          widgetName={FollowUpWidget.TASK_COUNT_CLOSED}
        />
      ),
    },
    [FollowUpWidget.TASK_STATUS]: {
      name: 'Follow Ups by Recruiters- Status Wise',
      filters: {},
      category: 'followUps',
      type: `table_followUps_recruiter_status_${timePeriodId}_${scope}_postgre`,
      component: (
        <FollowUpTablePostgres
          query={{
            ...defaultQuery,
            type: 'TASK_STATUS',
            filters: [
              {
                filterName: 'STATUS',
                values: ['OPEN', 'CLOSED'],
              },
            ],
          }}
          title="Follow Ups by Recruiters- Status Wise"
          widgetName={FollowUpWidget.TASK_STATUS}
          widgetType={`table_followUps_recruiter_status_${timePeriodId}_${scope}_postgre`}
        />
      ),
    },
    [FollowUpWidget.TASK_STATUS_BAR]: {
      name: 'Total Follow Ups created - Status Wise',
      filters: {},
      category: 'followUps',
      type: `stackedbarchart_followUps_recruiter_status_${timePeriodId}_${scope}_postgre`,
      component: (
        <FollowUpStackedBarChartPostgres
          query={{
            ...defaultQuery,
            type: 'TASK_STATUS_BAR',
            filters: [
              {
                filterName: 'STATUS',
                values: ['OPEN', 'CLOSED'],
              },
            ],
          }}
          title="Total Follow Ups created - Status Wise"
          widgetName={FollowUpWidget.TASK_STATUS_BAR}
        />
      ),
    },
  };
  return widgetConfig;
};

export const postgresFollowUpDashboardKeys = (
  timePeriodId: string,
  scope: ChartScope
): IComposableChartsWidget[] => {
  const defaultWidgetList = Object.values(followUpWidgetsByTimeAndScope(timePeriodId, scope));
  const extraWidgetList = {};

  return [...defaultWidgetList, ...(extraWidgetList[timePeriodId] ?? [])];
};

export const postgresFollowUpDashboardKeysObjectList = generalTimePeriodList.flatMap(
  (timePeriod) => [
    ...postgresFollowUpDashboardKeys(timePeriod?.id, ChartScope.WORKSPACE),
    ...postgresFollowUpDashboardKeys(timePeriod?.id, ChartScope.LOGGED_IN_USER),
    ...postgresFollowUpDashboardKeys(timePeriod?.id, ChartScope.TEAMS),
  ]
);
